



































































import VueOptions from '@utils/VueOptions'
import ResourceBindSelector from '@ui/ResourceBindSelector/ResourceBindSelector'
import LoadingIndicator from '@/components/LoadingIndicator'
import CalendarService from '@services/CalendarService'

settings =
  name: 'VenueDateBindSelector'

  resources:
    venue_resource:
      resourceName: 'venue'
      slug: 'suppliers/:supplierId/venues/:venue.id/edit'
      fetch: false

    calendar_dates:
      resourceName: 'calendar_date'
      slug: 'suppliers/:supplierId/calendar_dates'
      params:
        quick_list: true

  vue:
    props: ['venue']

    components: {
      ResourceBindSelector,
      LoadingIndicator,
    }

    data: ->
      selectedVenueDates: []
      selectedCalendarDates: []

    computed:
      supplierId: -> @venue?.top_org_id || @$store.member.supplier.id
      calendarDates: -> @calendar_dates || []
      venueDateIds: -> @venue.date_ids || []
      venueDates: ->
        items = []
        for date in (@calendarDates || [])
          items.push date if date.id in @venueDateIds
        items

      venueDatesTableData: ->
        for date in @venueDates
          { starts_on, repeats, rrule_string: rruleString } = date
          id: date.id
          data: date
          experience: date.creative_title
          date: CalendarService.formatCalendarDate({ date: starts_on, repeats, rruleString })

      calendarDatesTableData: ->
        for date in @calendarDates
          continue if date.id in @venueDateIds
          { starts_on, repeats, rrule_string: rruleString } = date
          id: date.id
          data: date
          experience: date.creative_title
          date: CalendarService.formatCalendarDate({ date: starts_on, repeats, rruleString })

      optionsForBindSelector: ->
        title: 'Venue Calendar'
        description: 'Setup the calendar for when sponsorships are available'
        addButtonText: 'Add New Date'
        addExistingButtonText: 'Add Existing Date'

    methods:
      hiVenueDatesSelectionChange: (dates) ->
        @selectedVenueDates = dates
      hiVenueDatesRowClick: (row) ->
        @$refs.venueDatesTable.toggleRowSelection row
      hiUnbindDate: (date) ->
        @unbindDatesFromVenueTrigger [date]
      hiUnbindSelectedDates: ->
        @unbindDatesFromVenueTrigger @selectedVenueDates

      hiCalendarDatesSelectionChange: (dates) ->
        @selectedCalendarDates = dates
      hiCalendarDatesRowClick: (row) ->
        @$refs.calendarDatesTable.toggleRowSelection row
      hiBindDate: (date) ->
        @bindDatesToVenueTrigger [date]
      hiBindSelectedDates: ->
        @$refs.bindSelector.close()
        @bindDatesToVenueTrigger @selectedCalendarDates

      bindDatesToVenueTrigger: (dates) ->
        payload = { calendar_date_ids: dates.map((d) => d.id) }
        @triggerResource 'venue_resource', 'bind_dates', payload
      onVenueResourceBindDates: (_, item) ->
        @$emit 'change', item

      unbindDatesFromVenueTrigger: (dates) ->
        payload = { calendar_date_ids: dates.map((d) => d.id) }
        @triggerResource 'venue_resource', 'unbind_dates', payload
      onVenueResourceUnbindDates: (_, item) ->
        @$refs.venueDatesTable?.clearSelection()
        @$emit 'change', item

export default VueOptions.vue settings
